import Vue from 'vue';

Vue.component('tng-subsidy-reimbursement-index', () =>
    import(/* webpackChunkName: 'tng-subsidy-reimbursement-index' */ './tng-subsidy-reimbursement-index.vue'),
);
